<template>
	<div class="jar">
		<div class="jar_main">
			<div class="jar_arc">
				<div class="arc_filling"></div>
			</div>
			<div class="jar_content" :style="size">
				<div class="waveBox" :style="`top: ${num}%`">
					<div class="wave"></div>
				</div>
				<div class="jar_content-slot">
					<slot></slot>
				</div>
			</div>
		</div>
		<div class="jar_bottom"></div>
	</div>
</template>

<script>
export default {
	props: {
		size: {
			type: Number,
			default: 50
		}
	},
	data() {
		return {
		};
	},
	computed: {
		num() {
			return 265 - this.size * 124 / 100;
		}
	}
};
</script>

<style lang="scss" scoped>
.jar {
	margin: 0 auto;
	width: 190px;
}
.jar_main {
	padding: 0 10px;
	.jar_arc {
		position: relative;
		height: 30px;
		overflow: hidden;
		.arc_filling {
			position: absolute;
			top: 0px;
			left: -52px;
    		width: 270px;
			height: 134px;
			border: 2px solid #459ee4;
			border-radius: 147px 147px 0 0;
		}
	}
	.jar_content {
		position: relative;
		min-height: 180px;
		background-color: #edf8fd;
		border: 2px solid #459ee4;
		overflow: hidden;
		.waveBox {
			position: absolute;
			top: 201%;
			width: 100%;
			height: 100%;
			z-index: 0;
		}
	}
}
.jar_content-slot {
	position: absolute;
	width: 100%;
	height: 100%;
}
.jar_bottom{
	height: 14px;
	background: #6eb3fc;
	border: 2px solid #459ee4;
	border-radius: 5px;
}

// 波浪
.wave {
	position: relative;
	width: 100%;
	height: 100%;

	&::before,
	&::after{
		content: "";
		position: absolute;
		width: 400px;
		height: 400px;
		top: 0%;
		background-color: #c4e7f8;
		border-radius: 45%;
		transform: translate(-50%, -70%) rotate(0);
		animation: rotate 6s linear infinite;
		z-index: 10;
	}

	&::before {
		left: 39%;
	}
		
	&::after {
		left: 59%;
		border-radius: 47%;
		background: linear-gradient(#94c8fd, #6bb1fc);
		transform: translate(-50%, -70%) rotate(0);
		animation: rotate 10s linear -5s infinite;
		z-index: 20;
	}
}
 
@keyframes rotate {
	50% {
		transform: translate(-50%, -73%) rotate(180deg);
	} 100% {
		transform: translate(-50%, -70%) rotate(360deg);
	}
}
</style>
